import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Table from "../../../components/Table";
import SearchFilter from "../../../components/SearchFilter";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import BranchesService from "../../../services/branch.service";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { useAlert } from "../../../context/AlertContext";

export default function BranchInformation() {
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState([]);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    { name: "BP Code", selector: (row) => row.Cus_NumBranch, sortable: true },
    { name: "รหัสสาขา", selector: (row) => row.Cus_Code, sortable: true },
    { name: "ชื่อสาขา", selector: (row) => row.Cus_Name, grow: 2 },
    { name: "สถานะ", selector: (row) => row.Branch_Status }
  ];
  const searchInput = [
    { name: "Cus_Code", label: "BP Master" },
    { name: "Cus_Name", label: "ชื่อลูกค้า" }
  ];

  useEffect(() => {

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: BranchesService.getAllBranches(),
      callback: (res) => setData(res)
    });

    
  }, []);

  return (
    <>
      <Helmet>
        <title>ตรวจสอบสถานะสาขา</title>
        <meta name="description" content="Check Branch Status Page" />
      </Helmet>

      <Container fluid className="p-3">
        <CardDisplayComponent
          body={{
            element: (
              <SearchFilter
                data={data}
                inputField={searchInput}
                fieldClassName={{ actionButton: "w-auto py-2" }}
                searchCallback={(search) => setSearchValue(search)}
              />
            )
          }}
        />

        <CardDisplayComponent
          header={{ title: { text: "ตรวจสอบสถานะสาขา" } }}
          body={{
            element: (
              <Table
                data={data}
                column={columns}
                pending={loading}
                searchFilter={searchValue}
              />
            )
          }}
        />
      </Container>
    </>
  );
}
